export const queryKeys = {
  getAllCategory: 'getAllCategory', //  获取所有分类
  getAllDepartment: 'getAllDepartment', // 获取所有部门
  getUserProfile: 'getUserProfile', // 获取用户信息
  getProductionOrder: 'getProductionOrder',
  getAllUsers: 'getAllUsers', // 获取所有用户
  getRole: 'getRole', // 获取角色
  getStatementIncomesPagination: 'getStatementIncomePagination', // 获取所有报表收入
  getStatementIncome: 'getStatementIncome', // 获取报表收入
  getStatementExpensesPagination: 'getStatementIncomePagination', // 获取所有报表支出
  getStatementExpenseIncome: 'getStatementIncome', // 获取报表支出
  getAllAssessmentDimensions: 'getAllAssessmentDimensions', // 获取所有维度
  getAllSubjects: 'getAllSubjects', // 获取所有科目
  getAllCurrencyConversions: 'getAllCurrencyConversions', // 获取所有汇率
  getRelatedStatementIncomes: 'getRelatedStatementIncomes', // 获取相关支出
  getRelatedStatementExpenses: 'getRelatedStatementExpenses', // 获取相关支出
  searchPlans: 'searchPlans', // 搜索计划
  filterPlans: 'filterPlans', // 过滤计划
  getAllPlans: 'getAllPlans', // 获取所有计划
  getPlan: 'getPlan', // 获取单个计划
  getAllProjects: 'getAllProjects', // 获取所有项目
  getProject: 'getProject', // 获取单个项目
  filterProjects: 'filterProjects', // 过滤项目
  getSubjectById: 'getSubjectById', // 获取科目
  getAllReportTemplates: 'getAllReportTemplates', // 获取所有报表模板
  getReportTemplateById: 'getReportTemplateById', // 获取报表模板
  getTemplate: 'getTemplate', // 获取单个模板
  getSystemTemplates: 'getSystemTemplates', // 获取系统模板
  getEnabledTemplate: 'getEnabledTemplate', // 获取启用的模板
  getTargetDifferenceList: 'getTargetDifferenceList', // 目标差异分析数据
  getAnalysisReportList: 'getAnalysisReportList', // 经营会计报表数据
  getAllActionPlans: 'getAllActionPlans', // 获取所有行动计划
  getAllInternalTradings: 'getAllInternalTradings', // 获取所有内部交易
  getAllOperationalStatementTransactions: 'getAllOperationalStatementTransactions', // 获取所有订单数据流水
  getAllSupportRequests: 'getAllSupportRequests', // 获取所有支援请求
  getSupportRequest: 'getSupportRequest', // 获取单个支援请求
  getAllProposals: 'getAllProposals', // 获取所有改善提案
  getProposal: 'getProposal', // 获取单个改善提案
  getAllTradeCategories: 'getAllTradeCategories', // 获取所有交易类型
};

export const mutationKeys = {
  addCategory: 'addCategory', // 添加分类
  createEnabledDashboard: 'createEnabledDashboard',
  updateEnabledDashboard: 'updateEnabledDashboard',
  addDepartment: 'addDepartment', // 添加部门
  updateDepartment: 'updateDepartment', // 更新部门
  updateCategory: 'updateCategory', // 更新分类
  uploadUserAvatar: 'uploadUserAvatar', // 上传用户头像
  createAssessmentDimension: 'createAssessmentDimension', // 创建维度
  updateAssessmentDimension: 'updateAssessmentDimension', // 更新维度
  createSubject: 'createSubject', // 创建科目
  updateSubject: 'updateSubject', // 更新科目
  createCurrencyConversion: 'createCurrencyConversion', // 创建汇率
  updateCurrencyConversion: 'updateCurrencyConversion', // 更新汇率
  createStatementIncome: 'createStatementIncome', // 创建报表收入
  updateStatementIncome: 'updateStatementIncome', // 更新报表收入
  createStatementExpense: 'createStatementExpense', // 创建报表支出
  updateStatementExpense: 'updateStatementExpense', // 更新报表支出
  createInternalTrading: 'createInternalTrading', // 创建内部交易
  updateInternalTrading: 'updateInternalTrading', // 更新内部交易
  deleteInternalTrading: 'deleteInternalTrading', // 删除内部交易
  createSupportRequest: 'createSupportRequest', // 创建支援请求
  updateSupportRequest: 'updateSupportRequest', // 更新支援请求
};
